<template>
  <div>
    <v-list>
      <ListItem
        :title="school.name"
        :subtitle="$t('fields.name')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'SchoolDetails',
    components: { ListItem },
    props: {
      school: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
